export default __webpack_public_path__ + "static/media/cs50.da7c22cc.jpg";